import { Permission } from '@ruta/shared';
import { usePermission } from './usePermission';

/**
 * Who is allowed to see Ruta AI — owners and admins only.
 *
 * Gated on SETTINGS_MANAGE, which owners and admins hold and crew leaders /
 * crew members never do. Crew roles get NOTHING: no header sparkle, no Cmd-K,
 * no "Explain this review" button, no dock. (Benny: "we'll open it to crews
 * later.") To grant another role access, change the permission on the line below.
 */
export function useRutaAiAccess(): boolean {
  return usePermission(Permission.SETTINGS_MANAGE);
}
